<script>
  import { getContext, setContext } from "svelte";
  import { GridContainer, ListThumbnail } from "@ObamaFoundation/of-design-system";

  /** @type { string } */
  let className = "";
  export { className as class };
  export let data;

  const isContainerized = !!getContext("containerized");

  if (!isContainerized) {
    setContext("containerized", true);
  }
</script>

{#if isContainerized}
  <ListThumbnail {data} class={className} />
{:else}
  <GridContainer containerClass={className}>
    <ListThumbnail {data} />
  </GridContainer>
{/if}
